import { render, staticRenderFns } from "./ImageOverlay.vue?vue&type=template&id=333989ad&scoped=true&"
import script from "./ImageOverlay.vue?vue&type=script&lang=ts&"
export * from "./ImageOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ImageOverlay.vue?vue&type=style&index=0&id=333989ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333989ad",
  null
  
)

export default component.exports